import { NavigationBar as CDSNavigationbar } from '@cbhq/cds-web/navigation/NavigationBar';

import { ErrorBoundary } from './ProfileMenu/components/ErrorBoundary';
import { ClientPropsProvider } from './ProfileMenu/providers/ClientPropsProvider';
import { TopRight } from './TopRight';
import { NavbarProps } from './types';
import { PACKAGE_VERSION_NAME } from './version';

export function NavigationBar(clientProps: NavbarProps) {
  return (
    <ClientPropsProvider profileDropdownProps={clientProps}>
      <ErrorBoundary fallback={clientProps.boundaryFallback}>
        <CDSNavigationbar {...clientProps} end={<TopRight />} data-version={PACKAGE_VERSION_NAME}>
          {clientProps.children}
        </CDSNavigationbar>
      </ErrorBoundary>
    </ClientPropsProvider>
  );
}
